module.exports = __webpack_public_path__ + "static/img/mole.512940ea.gif";